<template>
  <div>
    <BaseButton ghost small @click="confirmDelete"> Delete </BaseButton>
  </div>
</template>

<script>
import { funnelStagesClient } from '@/api/clients';

export default {
  props: {
    funnelStageId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    async destroy() {
      try {
        await funnelStagesClient.destroy(this.funnelStageId);

        this.$emit('deleted');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    confirmDelete() {
      this.$modal.show({
        component: () => import('Components/FunnelStage/FunnelStageDeleteModal.vue'),
        props: {
          action: this.destroy,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
